<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import {JIRA_SITE_URL, flagTypes} from '../../../constants.js';
    import {sgettext} from '../../../i18n.js';

    export let row;

    function getSupervisorIssueId() {
        let id = 0;
        const supervisor_issue = row.linked_issues.find(i => i.type === flagTypes.help ||
                i.type === flagTypes.additionalWorkRequired);
        if (supervisor_issue) {
            id = supervisor_issue.id;
        }
        return id;
    }
</script>

{#if row.linked_issues && row.linked_issues.length}
    {#if row.type === flagTypes.improvement && row.linked_issues[0].type === flagTypes.help}
        <div><a href="{`${PATH_PREFIX}/sw/common/issues/${getSupervisorIssueId()}/`}">{sgettext('$$VIEW_ISSUE$$')}</a></div>
    {:else if row.type === 'HELP'}
        <div>
            <div>{`View ${row.linked_issues.length > 1 ? sgettext('$$IMPROVEMENTS$$') : sgettext('$$IMPROVEMENT$$')}`}</div>
            <ul>
                {#each row.linked_issues.filter(i => i.type === flagTypes.improvement) as issue}
                    <li><a href="{`${PATH_PREFIX}/sw/common/issues/${issue.id}/`}">{issue.value}</a></li>
                {/each}
            </ul>
        </div>

    {/if}
{/if}

{#if row.jira_id}
    <div><a href="{`${JIRA_SITE_URL}browse/${row.jira_id}`}" target="_blank" rel="noopener noreferrer">{sgettext('$$VIEW_JIRA_TICKET$$')} - {row.jira_id}</a></div>
{/if}